import React from 'react';
import { IconSvgProps } from '@models/common';

const TextUndo: React.FC<IconSvgProps> = (props) => {
  const { size = 16, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M2.72563 4.94228C3.46675 3.6632 4.64746 2.69705 6.0479 2.22373C7.44835 1.7504 8.97309 1.80215 10.3382 2.36935C11.7034 2.93655 12.8158 3.98054 13.4685 5.30693C14.1212 6.63331 14.2696 8.1517 13.8861 9.57936C13.5026 11.007 12.6133 12.2467 11.3838 13.0674C10.1544 13.8882 8.66849 14.2342 7.2029 14.041C5.7373 13.8478 4.39187 13.1286 3.41711 12.0172C2.44236 10.9058 1.90472 9.47808 1.9043 7.9998'
        stroke='currentColor'
        strokeWidth='1.33'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.71363 4.9524H2.66602V1.90479'
        stroke='currentColor'
        strokeWidth='1.33'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default TextUndo;
